import React from "react";
import ModalV2 from "components/ModalV2/ModalV2";
import ModalV2Buttons from "components/ModalV2Buttons/ModalV2Buttons";

export default function InvitationInvalidModal({
  open,
  title = "Join an account",
  description,
  onCancel,
  onJoin,
  cancelText = "Cancel",
  joinText = "Join account",
}) {
  return (
    <ModalV2
      open={open}
      onClose={onCancel}
      showClose={false}
      closeOnOverlayClick={true}
      closeOnEsc={true}
      width={560}
      title={title}
      description={description}
      footer={() => (
        <ModalV2Buttons
          onCancel={onCancel}
          onConfirm={onJoin}
          cancelText={cancelText}
          confirmText={joinText}
          variant="primary"
        />
      )}
    />
  );
}
